export default __webpack_public_path__ + "static/media/r6e-logo-ru-RU.40bc7f2c.png";